import React, {Component} from 'react';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import lscache from 'lscache'
import {Label} from "reactstrap";
import {observer} from "mobx-react";
import { Redirect } from "react-router-dom";
import {makePDF} from "../../../../utils/formatar";


@observer
class TermoDeAceite extends Component {
    constructor(props) {
        super(props);
        this.controller = props.controller;

        
        this.state = {
            cancelar: false
        }
    }


    isInRole(valor){
        if(lscache.get("Perfil").find(item => item == valor)) return true
    }

    termoCliente = () => {
        const data = new Date();
        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0')
        const ano = data.getFullYear();
        const dataAt = `${dia}/${mes}/${ano}`

        return <div className="modal-texto">
                        <Label>Para prosseguir, Será necessário aceitar o termo.</Label>

                        
            <h5>Declaramos, para os devidos fins, que concordamos com os custos de Armazenagem por container, desde a sua entrada até o embarque.</h5>
             <h5>A Armazenagem será cobrada conforme contrato celebrado com o Terminal, e em casos de ausência de contrato, será cobrado conforme Tabela Pública.</h5>

                <Label className="justify-content-end"> Na data de: {dataAt}</Label>
        </div>
    };

    termoArmador = () => {
        const data = new Date();
        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0')
        const ano = data.getFullYear();
        const dataAt = `${dia}/${mes}/${ano}`

        return <div className="modal-texto">

        <h5>Declaramos, para os devidos fins, que concordamos com os custos de Armazenagem por container, desde a sua entrada até o embarque.</h5>

        <h5>A Armazenagem será cobrada conforme contrato celebrado com o Terminal, e em casos de ausência de contrato, será cobrado conforme Tabela Pública.</h5>

         <Label className="justify-content-end"> Na data de: {dataAt}</Label>
        </div>
    }

    render() {        
        if (this.state.cancelar)
            return <Redirect to='/programacao-navios' />;

        return <ModalContainer zIndex={100} className="modal-layer">
            <ModalDialog className="nosso-modal modal-escolhas">
                <h2>Termo de Aceite</h2>
                {this.isInRole("CLIENTE") ? this.termoCliente()  : this.termoArmador()}
               
                <div className="botoes">
                    <div className="justify-content-end">
                        <Label className="btn-primary cinza" onClick={ () => this.setState({cancelar: true}) }>CANCELAR</Label>
                        <Label className="btn-primary" onClick={ () => this.controller.aceitarTermo() }>LI E ACEITO OS TERMOS</Label>
                    </div>
                </div>
            </ModalDialog>
        </ModalContainer>
    }
}
 
export default TermoDeAceite;




// WEBPACK FOOTER //
// ./src/modules/agendamento/entrada-antecipada/components/TermoDeAceite.js